export const getInitial = (
  firstName: string | undefined,
  lastName: string | undefined
): string => {
  return `${firstName?.[0]}${lastName?.[0]}`;
};
